import React from 'react';

const FileInput = ({ onChange, fileName }) => {
	const handleDrop = (e) => {
		e.preventDefault();
		const file = e.dataTransfer.files[0];
		if (file && file.type === 'text/csv') {
			onChange && onChange({ target: { files: [file] } }); // simulate input change
		} else {
			alert('Please upload a valid CSV file exported from ZOTERO.');
		}
	};

	const handleDragOver = (e) => {
		e.preventDefault();
	};

	const handleFileChange = (e) => {
		const file = e.target.files[0];
		if (file && file.type === 'text/csv') {
			onChange && onChange(e);
		} else {
			alert('Please upload a valid CSV file exported from ZOTERO.');
		}
	};

	return (
		<>
			<div
				className='w-full mx-auto border border-gray-300 mt-8 rounded-lg shadow-md  text-center cursor-pointer bg-white relative'
				onDrop={handleDrop}
				onDragOver={handleDragOver}
			>
				<div
					className='block text-xl text-black font-semibold top-[-38px] left-0 absolute'
					htmlFor='institution-code'
				>
					File
				</div>
				<label
					htmlFor='file-upload'
					className='cursor-pointer flex flex-col items-center gap-4  p-10'
				>
					<svg
						xmlns='http://www.w3.org/2000/svg'
						className='h-10 w-10 text-gray-600'
						fill='none'
						viewBox='0 0 24 24'
						stroke='currentColor'
						strokeWidth={2}
					>
						<path
							strokeLinecap='round'
							strokeLinejoin='round'
							d='M12 4v16m8-8H4'
						/>
					</svg>
					<p className='text-gray-600'>
						<span className='font-semibold text-gray-800'>Click to upload</span>{' '}
						or drag and drop
						<br />
						only <span className='font-bold'>CSV</span> (Exported from{' '}
						<span className='font-bold'>ZOTERO</span>)
					</p>
					{fileName && (
						<p className='text-green-600 font-medium'>Selected: {fileName}</p>
					)}
					<input
						id='file-upload'
						type='file'
						accept='.csv'
						className='hidden'
						onChange={handleFileChange}
					/>
				</label>
			</div>
		</>
	);
};

export default FileInput;
